/**
 * Represents the type of UI control to use for input.
 */
enum InputComponentType {
    TEXT,
    DROPDOWN,
}

export default InputComponentType;
